import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';

const ExportCsvButton = ({ csv, name, disabled, className }) => {
  const cssClass = classnames(
    'c-btn c-btn--medium u-mb0',
    className,
    {
      'is-disabled': disabled,
    },
  );
  if (typeof csv === 'function') {
    return (
      <a
        onClick={csv}
        className={cssClass}
      >
        <span className="c-btn__text">{t('reports:export_csv_button')}</span>
      </a>
    );
  }
  return (
    <a
      href={`data:attachment/csv,${encodeURIComponent(csv)}`}
      download={name}
      className={cssClass}
    >
      <span className="c-btn__text">{t('reports:export_csv_button')}</span>
    </a>
  );
};

ExportCsvButton.propTypes = {
  csv: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]).isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

ExportCsvButton.defaultProps = {
  name: '',
  disabled: false,
  className: '',
};

export default ExportCsvButton;
